import React from 'react';
import { useBrand } from '../context/BrandContext';

interface HeadingProps {
  title: string;
  subtitle?: string;
  className?: string;
  titleWeight?: 'bold' | 'regular';
}

const Heading: React.FC<HeadingProps> = ({ title, subtitle, className = '', titleWeight = 'bold' }) => {
  const { brandConfig } = useBrand();
  
  const getTitleFontWeight = () => {
    return brandConfig.typography.headingWeights.title[titleWeight];
  };

  const renderTextWithLineBreaks = (text: string) => {
    return text.split('\n').map((line, index) => (
      <span key={index} className="block">
        {line}
      </span>
    ));
  };
  
  return (
    <div
      className={`box-border content-stretch flex flex-col gap-8 items-center justify-start leading-none p-0 text-center ${className}`}
      data-name="Heading"
      data-node-id="61:360"
      style={{ fontSize: 'var(--brand-font-size-heading-title)' }}
    >
      <div
        className="relative shrink-0 text-brand-text-primary tracking-tight w-full font-brand-primary"
        data-node-id="61:333"
        style={{ fontWeight: getTitleFontWeight() }}
      >
        <p className="block leading-tight text-inherit">
          {renderTextWithLineBreaks(title)}
        </p>
      </div>
      {subtitle && (
        <div
          className="relative shrink-0 text-brand-text-secondary tracking-tight w-full font-brand-secondary"
          data-node-id="61:359"
          style={{ 
            fontSize: 'var(--brand-font-size-heading-subtitle)',
            fontWeight: brandConfig.typography.headingWeights.title.regular
          }}
        >
          <p className="block leading-tight">
            {renderTextWithLineBreaks(subtitle)}
          </p>
        </div>
      )}
    </div>
  );
};

export default Heading;
